import axios from 'axios'

export default {
  search: function (request) {
    return axios.get('/api/admin/users/search', { params: request });
  },
  find: function (id) {
    return axios.get(`/api/admin/users/find?id=${id}`);
  },
  create: function (data, base_url) {
    return axios.post(`/api/admin/users?base_url=` + base_url, data);
  },
  update: function(data) {
    return axios.put(`/api/admin/users/${data.id}`, data);
  },
  delete: function (id) {
    return axios.delete(`/api/admin/users/${id}`);
  },
  currentUserOrgs: function() {
    return axios.get('api/admin/users/CurrentUserOrganizations');
  },
  importExcel: function(name, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post( `/api/admin/users/import`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
    );
  }
}